import axios from 'axios';
import { isPullRequestApp } from './config';
import urls from '../constants/urls';

const API_LOCAL_STORAGE_KEY = 'currentApi.details';

export const storeApiDetails = details => {
  localStorage.setItem(API_LOCAL_STORAGE_KEY, JSON.stringify(details));
  localStorage.setItem(
    'i18nextLng',
    `en-${details.attributes['country-code'].toUpperCase()}`
  );
};

export const clearApiDetails = () => {
  localStorage.removeItem(API_LOCAL_STORAGE_KEY);
  localStorage.removeItem('i18nextLng');
};

export const retrieveApiDetails = () => {
  let api;

  if (isPullRequestApp) {
    api = {
      id: '0',
      type: 'pull-request',
      attributes: {
        'country-code': 'gb',
        features: [
          'nhs_auth',
          'role_based_messaging',
          'trust_messaging',
          'critical_alerts',
          'directory_monitoring',
          'locking_numbers_enabled',
        ],
        name: 'Pull Request',
        url: urls.reviewAppUrl,
        'auth-url': urls.switchAppUrl,
      },
    };

    storeApiDetails(api);
  } else {
    api = JSON.parse(localStorage.getItem(API_LOCAL_STORAGE_KEY));
  }

  return api;
};

export const setupAxiosForApi = url => {
  let sessionToken = localStorage.getItem('currentUser.sessionToken');

  axios.defaults.baseURL = urls.baseInductionUrl(url);
  if (sessionToken) {
    axios.defaults.headers.common.Authorization = `Token token=${sessionToken}`;
  }
};

export const attemptAxiosApiSetup = () => {
  let currentApiDetails = retrieveApiDetails();

  if (currentApiDetails) {
    setupAxiosForApi(currentApiDetails.attributes.url);
  }
};
